import { Routes } from '@angular/router';
import { policyRoutes } from './policy.routes';

const deliveriesDashboardRoute = {
    path: 'deliveries-dashboard',
    loadChildren: () =>
        import('../pages/deliveries-dashboard/deliveries-dashboard.routes').then(
            m => m.deliveriesDashboardRoutes
        ),
};

const settingsRoute = {
    path: 'settings',
    loadChildren: () =>
        import('../pages/settings/settings.routes').then(m => m.settingsRoutes),
};

const subscriptionDashboardRoute = {
    path: 'subscription-dashboard',
    loadChildren: () =>
        import('../pages/subscription-dashboard/subscription-dashboard.routes').then(
            m => m.subscriptionDashboardRoutes
        ),
};

const subscriptionActivatedRoute = {
    path: 'subscription-activated',
    loadChildren: () =>
        import('../pages/subscription-activated/subscription-activated.routes').then(
            m => m.subscriptionActivatedRoutes
        ),
};

export const protectedRoutes: Routes = [
    deliveriesDashboardRoute,
    settingsRoute,
    subscriptionDashboardRoute,
    subscriptionActivatedRoute,
    ...policyRoutes,
    { path: '**', redirectTo: 'deliveries-dashboard' },
];
